import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { CookieConsentProvider } from './contexts/CookieConsentContext.jsx';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import VerifyEmail from './pages/VerifyEmail';
import Dashboard from './pages/Dashboard';
import JobDetail from './pages/JobDetail';
import PartnerCreditCheckSection from './pages/PartnerSection';
import User_page from './pages/User_page';
import CookieBanner from './components/CookieBanner';
import './App.css';

function PrivateRoute({ children }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
}

function PublicRoute({ children }) {
  const { isAuthenticated } = useAuth();
  return !isAuthenticated ? <>{children}</> : <Navigate to="/User_page" replace />;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={
        <PublicRoute>
          <Login />
        </PublicRoute>
      } />
      <Route path="/register" element={
        <PublicRoute>
          <Register />
        </PublicRoute>
      } />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/dashboard" element={
        <PrivateRoute>
          <Dashboard />
        </PrivateRoute>
      } />
      <Route path="/jobs/:jobId" element={
        <PrivateRoute>
          <JobDetail />
        </PrivateRoute>
      } />
      <Route path="/partner" element={<PartnerCreditCheckSection />} />
      <Route path="/User_page" element={
        <PrivateRoute>
          <User_page />
        </PrivateRoute>
      } />
    </Routes>
  );
}

function App() {
  return (
    <LanguageProvider>
      <CookieConsentProvider>
        <AuthProvider>
          <CookieBanner />
          <AppRoutes />
        </AuthProvider>
      </CookieConsentProvider>
    </LanguageProvider>
  );
}

export default App;

